import { render } from "./company-panel.vue?vue&type=template&id=01daaae0&scoped=true&ts=true"
import script from "./company-panel.vue?vue&type=script&lang=ts"
export * from "./company-panel.vue?vue&type=script&lang=ts"

import "./company-panel.vue?vue&type=style&index=0&id=01daaae0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01daaae0"]])

export default __exports__